(function () {
    if (window.__kremLabCartThresholdGiftsInit) return;
    window.__kremLabCartThresholdGiftsInit = true;

    const GIFT_VARIANTS = [
        {
            id: 56653812433282,
            threshold: 9900,
            label: 'Kosmetyczka beżowa Purles',
        },
        {
            id: 56653849952642,
            threshold: 19900,
            label: 'Kuferek kosmetyczny jasny fiolet Purles',
        },
        {
            id: 56653865681282,
            threshold: 29900,
            label: 'Torba plażowa kremowa Purles',
        },
    ];
    const GIFT_VARIANT_IDS = new Set(GIFT_VARIANTS.map((gift) => String(gift.id)));
    const BUSY_CLASS = 'cart-gifts--busy';
    const ACCELERATED_DISABLED_CLASS = 'sales-document__accelerated-disabled';

    let operationInFlight = null;
    let updateTimer = null;
    let lastCart = null;
    let useCartUpdateFallback = ['127.0.0.1', 'localhost'].includes(window.location.hostname);

    function getGiftByVariantId(variantId) {
        return GIFT_VARIANTS.find((gift) => String(gift.id) === String(variantId)) || null;
    }

    function formatMoney(cents) {
        return new Intl.NumberFormat('pl-PL', {
            style: 'currency',
            currency: 'PLN',
        })
            .format(Math.max(0, cents) / 100)
            .replace(/\u00a0/g, ' ');
    }

    function withJsEndpoint(url, fallback) {
        const resolved = String(url || '').trim() || fallback;
        if (/\.js([?#]|$)/.test(resolved)) return resolved;

        const [path, suffix = ''] = resolved.split(/([?#].*)/, 2);
        return `${path}.js${suffix}`;
    }

    function getCartJsonUrl() {
        return withJsEndpoint(window.routes?.cart_url, '/cart.js');
    }

    function getCartAddUrl() {
        return withJsEndpoint(window.routes?.cart_add_url, '/cart/add.js');
    }

    function getCartChangeUrl() {
        return withJsEndpoint(window.routes?.cart_change_url, '/cart/change.js');
    }

    function getCartUpdateUrl() {
        return withJsEndpoint(window.routes?.cart_update_url, '/cart/update.js');
    }

    async function parseJsonResponse(response, errorMessage) {
        if (!response.ok) {
            throw new Error(`${errorMessage} (${response.status})`);
        }

        return response.json();
    }

    function rememberCart(cart) {
        if (cart && Array.isArray(cart.items)) {
            lastCart = cart;
        }

        return cart;
    }

    function getCartSectionIds() {
        if (!window.cartBase || typeof window.cartBase.getSectionsToRender !== 'function') {
            return [];
        }

        return window.cartBase
            .getSectionsToRender()
            .map((section) => section.id)
            .filter(Boolean);
    }

    function updateCartSectionsFromResponse(response) {
        if (!response?.sections || !window.cartBase || typeof window.cartBase.updateSections !== 'function') {
            return false;
        }

        window.cartBase.updateSections({ sections: response.sections });
        return true;
    }

    function getCartFromResponse(response) {
        if (response && Array.isArray(response.items) && typeof response.total_price === 'number') {
            return rememberCart(response);
        }

        return null;
    }

    function getAddedGiftItemFromResponse(response, gift) {
        const candidates = Array.isArray(response?.items) ? response.items : [response];

        return (
            candidates.find((item) => {
                return String(item?.variant_id || item?.id || '') === String(gift.id);
            }) || null
        );
    }

    function buildCartWithSelectedGift(cart, gift, addResponse) {
        if (!cart || !Array.isArray(cart.items)) return null;

        const addedGift = getAddedGiftItemFromResponse(addResponse, gift);
        const giftLine = {
            ...(addedGift || {}),
            id: addedGift?.id || gift.id,
            variant_id: addedGift?.variant_id || gift.id,
            key: addedGift?.key || `gift-${gift.id}`,
            quantity: 1,
            final_line_price: Number(addedGift?.final_line_price || 1),
        };

        return rememberCart({
            ...cart,
            items: [...cart.items.filter((item) => !GIFT_VARIANT_IDS.has(String(item.variant_id))), giftLine],
        });
    }

    async function setSelectedGiftWithCartUpdate(cart, gift) {
        if (!cart || !Array.isArray(cart.items)) return null;

        const updates = {};
        getGiftItems(cart).forEach((item) => {
            updates[item.key] = 0;
        });
        updates[String(gift.id)] = 1;

        const sections = getCartSectionIds();
        const payload = {
            updates,
        };

        if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
        }

        const response = await fetch(getCartUpdateUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify(payload),
        });

        return rememberCart(await parseJsonResponse(response, 'Nie udało się zmienić prezentu w koszyku.'));
    }

    async function fetchCartViaUpdate() {
        if (!useCartUpdateFallback && window.cartBase && typeof window.cartBase.getData === 'function') {
            try {
                const cart = await window.cartBase.getData();
                if (cart && Array.isArray(cart.items)) {
                    return rememberCart(cart);
                }

                throw new Error(cart?.errors || 'cartBase.getData nie zwrócił poprawnych danych koszyka.');
            } catch (error) {
                console.warn('[Cart gifts] Fallback cartBase.getData nie zwrócił koszyka.', error);
            }
        }

        const response = await fetch(getCartUpdateUrl(), {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
            credentials: 'same-origin',
            body: JSON.stringify({}),
        });

        return rememberCart(await parseJsonResponse(response, 'Nie udało się pobrać koszyka.'));
    }

    async function fetchCart(options = {}) {
        const allowFallback = options.allowFallback !== false;

        if (allowFallback && useCartUpdateFallback) {
            return fetchCartViaUpdate();
        }

        const response = await fetch(getCartJsonUrl(), {
            headers: {
                Accept: 'application/json',
            },
            credentials: 'same-origin',
            cache: 'no-store',
        });

        try {
            return rememberCart(await parseJsonResponse(response, 'Nie udało się pobrać koszyka.'));
        } catch (error) {
            if (!allowFallback) throw error;

            useCartUpdateFallback = true;
            return fetchCartViaUpdate();
        }
    }

    function getGiftItems(cart) {
        return (cart.items || []).filter((item) => GIFT_VARIANT_IDS.has(String(item.variant_id)));
    }

    function getSubtotalWithoutGifts(cart) {
        return (cart.items || []).reduce((sum, item) => {
            if (GIFT_VARIANT_IDS.has(String(item.variant_id))) return sum;
            return sum + Number(item.final_line_price || 0);
        }, 0);
    }

    function getUnlockedGifts(subtotal) {
        return GIFT_VARIANTS.filter((gift) => subtotal >= gift.threshold);
    }

    function getNextGift(subtotal) {
        return GIFT_VARIANTS.find((gift) => subtotal < gift.threshold) || null;
    }

    function getSelectedGiftItem(cart) {
        const subtotal = getSubtotalWithoutGifts(cart);
        return (
            getGiftItems(cart).find((item) => {
                const gift = getGiftByVariantId(item.variant_id);
                return gift && subtotal >= gift.threshold;
            }) || null
        );
    }

    function getGiftRuleChanges(cart) {
        const subtotal = getSubtotalWithoutGifts(cart);
        const giftItems = getGiftItems(cart);
        const eligibleGiftItems = giftItems.filter((item) => {
            const gift = getGiftByVariantId(item.variant_id);
            return gift && subtotal >= gift.threshold;
        });
        const keepItem = eligibleGiftItems[0] || null;
        const changes = [];

        giftItems.forEach((item) => {
            if (!keepItem || item.key !== keepItem.key) {
                changes.push({
                    key: item.key,
                    quantity: 0,
                });
                return;
            }

            if (item.quantity !== 1) {
                changes.push({
                    key: item.key,
                    quantity: 1,
                });
            }
        });

        return changes;
    }

    function hasGiftRuleViolations(cart) {
        return Boolean(cart && Array.isArray(cart.items) && getGiftRuleChanges(cart).length);
    }

    function setBusy(isBusy) {
        document.querySelectorAll('[data-cart-gifts]').forEach((widget) => {
            widget.classList.toggle(BUSY_CLASS, isBusy);
            widget.setAttribute('aria-busy', isBusy ? 'true' : 'false');
        });

        document
            .querySelectorAll('.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons')
            .forEach((element) => {
                element.classList.toggle(ACCELERATED_DISABLED_CLASS, isBusy);
            });
    }

    function updateWidget(widget, cart) {
        const subtotal = getSubtotalWithoutGifts(cart);
        const selectedGiftItem = getSelectedGiftItem(cart);
        const selectedVariantId = selectedGiftItem ? String(selectedGiftItem.variant_id) : '';
        const unlockedGifts = getUnlockedGifts(subtotal);
        const nextGift = getNextGift(subtotal);
        const status = widget.querySelector('[data-cart-gifts-status]');
        const progress = widget.querySelector('[data-cart-gifts-progress]');

        if (status) {
            if (selectedGiftItem) {
                const nextMessage = nextGift
                    ? ` Do kolejnego progu brakuje ${formatMoney(nextGift.threshold - subtotal)}.`
                    : '';
                status.textContent = `Prezent za 1 gr jest w koszyku.${nextMessage}`;
            } else if (unlockedGifts.length) {
                const nextMessage = nextGift
                    ? ` Do kolejnego progu brakuje ${formatMoney(nextGift.threshold - subtotal)}.`
                    : '';
                status.textContent = `Możesz wybrać prezent za 1 gr.${nextMessage}`;
            } else if (nextGift) {
                status.textContent = `Do prezentu za 1 gr brakuje ${formatMoney(nextGift.threshold - subtotal)}.`;
            } else {
                status.textContent = 'Możesz wybrać prezent za 1 gr.';
            }
        }

        if (progress) {
            const maxThreshold = GIFT_VARIANTS[GIFT_VARIANTS.length - 1].threshold;
            const percent = Math.min(100, Math.max(0, (subtotal / maxThreshold) * 100));
            progress.style.width = `${percent}%`;
        }

        widget.querySelectorAll('[data-cart-gifts-step]').forEach((step) => {
            const threshold = Number(step.dataset.cartGiftsStep || 0);
            step.classList.toggle('is-active', subtotal >= threshold);
        });

        widget.querySelectorAll('[data-cart-gift]').forEach((card) => {
            const variantId = String(card.dataset.giftVariantId || '');
            const gift = getGiftByVariantId(variantId);
            const button = card.querySelector('[data-cart-gift-add]');
            const isAvailable = card.dataset.giftAvailable === 'true';
            const isUnlocked = Boolean(gift && subtotal >= gift.threshold);
            const isSelected = selectedVariantId === variantId;

            card.classList.toggle('is-unlocked', isUnlocked);
            card.classList.toggle('is-selected', isSelected);
            card.classList.toggle('is-locked', !isUnlocked);
            card.classList.toggle('is-unavailable', !isAvailable);

            if (!button) return;

            if (!isAvailable) {
                button.textContent = 'Niedostępny';
                button.disabled = true;
            } else if (isSelected) {
                button.textContent = 'Dodano';
                button.disabled = true;
            } else if (isUnlocked) {
                button.textContent = selectedVariantId ? 'Zmień prezent' : 'Dodaj za 1 gr';
                button.disabled = Boolean(operationInFlight);
            } else if (gift) {
                button.textContent = `Brakuje ${formatMoney(gift.threshold - subtotal)}`;
                button.disabled = true;
            }
        });
    }

    function updateWidgets(cart) {
        document.querySelectorAll('[data-cart-gifts]').forEach((widget) => {
            updateWidget(widget, cart);
        });
    }

    function isGiftCardUnlocked(card) {
        return Boolean(card && card.classList.contains('is-unlocked') && !card.classList.contains('is-unavailable'));
    }

    async function getCartForGiftChoice(gift, card) {
        if (lastCart && isGiftCardUnlocked(card)) {
            return lastCart;
        }

        try {
            return await fetchCart();
        } catch (error) {
            if (!isGiftCardUnlocked(card)) {
                throw error;
            }

            console.warn('[Cart gifts] Pomijam kontrolny odczyt koszyka, bo prezent jest już odblokowany w UI.', error);
            return lastCart;
        }
    }

    async function changeLineItemWithCartBase(itemKey, quantity) {
        if (!window.cartBase || typeof window.cartBase.sendRequest !== 'function') {
            return null;
        }

        const body = new FormData();
        body.append('id', itemKey);
        body.append('quantity', String(quantity));

        const response = await window.cartBase.sendRequest({
            url: window.routes?.cart_change_url || '/cart/change',
            body,
            target: {
                onError(errors) {
                    console.warn('[Cart gifts] Błąd aktualizacji prezentu.', errors);
                },
            },
        });

        if (response?.errors) {
            throw new Error(Array.isArray(response.errors) ? response.errors.join(' ') : String(response.errors));
        }

        return rememberCart(response);
    }

    async function changeLineItem(itemKey, quantity) {
        try {
            const response = await fetch(getCartChangeUrl(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify({
                    id: itemKey,
                    quantity,
                }),
            });

            if (!response.ok) {
                throw new Error('Nie udało się zaktualizować prezentu w koszyku.');
            }

            return rememberCart(await response.json());
        } catch (error) {
            if (useCartUpdateFallback) throw error;

            const cartBaseResponse = await changeLineItemWithCartBase(itemKey, quantity);
            if (cartBaseResponse) return cartBaseResponse;

            throw error;
        }
    }

    async function addGiftWithCartBase(gift) {
        if (!window.cartBase || typeof window.cartBase.sendRequest !== 'function') {
            return null;
        }

        const body = new FormData();
        body.append('id', String(gift.id));
        body.append('quantity', '1');
        body.append('properties[_prezent]', 'Prezent za 1 gr');
        body.append('properties[_prog]', `${Math.round(gift.threshold / 100)} zł`);

        const response = await window.cartBase.sendRequest({
            url: window.routes?.cart_add_url || '/cart/add',
            body,
            target: {
                onError(errors) {
                    console.warn('[Cart gifts] Błąd dodawania prezentu.', errors);
                },
            },
        });

        if (response?.errors) {
            throw new Error(Array.isArray(response.errors) ? response.errors.join(' ') : String(response.errors));
        }

        return response;
    }

    async function addGift(gift) {
        const sections = getCartSectionIds();
        const payload = {
            items: [
                {
                    id: gift.id,
                    quantity: 1,
                    properties: {
                        _prezent: 'Prezent za 1 gr',
                        _prog: `${Math.round(gift.threshold / 100)} zł`,
                    },
                },
            ],
        };

        if (sections.length) {
            payload.sections = sections;
            payload.sections_url = window.location.pathname;
        }

        try {
            const response = await fetch(getCartAddUrl(), {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Accept: 'application/json',
                },
                credentials: 'same-origin',
                body: JSON.stringify(payload),
            });

            if (!response.ok) {
                throw new Error('Nie udało się dodać prezentu do koszyka.');
            }

            return response.json();
        } catch (error) {
            if (useCartUpdateFallback) throw error;

            const cartBaseResponse = await addGiftWithCartBase(gift);
            if (cartBaseResponse) return cartBaseResponse;

            throw error;
        }
    }

    async function refreshCartSections() {
        if (window.cartBase && typeof window.cartBase.refreshCart === 'function') {
            window.cartBase.isSectionsValidated = false;
            await window.cartBase.refreshCart();
        }
    }

    async function refreshAfterMutation(mutationResponse, optimisticCart) {
        const sectionsUpdated = updateCartSectionsFromResponse(mutationResponse);
        let cart = getCartFromResponse(mutationResponse) || optimisticCart || null;

        if (!sectionsUpdated) {
            await refreshCartSections();
        }

        if (!cart) {
            try {
                cart = await fetchCart();
            } catch (error) {
                console.warn('[Cart gifts] Nie udało się odświeżyć danych koszyka po zmianie.', error);
            }
        }

        if (cart) {
            updateWidgets(cart);
        }

        document.dispatchEvent(
            new CustomEvent('krem:cart-gifts-updated', {
                detail: {
                    cart,
                },
            })
        );
        return cart;
    }

    async function enforceGiftRules(cart) {
        if (operationInFlight) return cart;

        const changes = getGiftRuleChanges(cart);
        if (!changes.length) return cart;

        setBusy(true);

        try {
            for (const change of changes) {
                await changeLineItem(change.key, change.quantity);
            }

            return refreshAfterMutation();
        } finally {
            setBusy(false);
        }
    }

    async function normalizeGiftRules() {
        if (operationInFlight) {
            try {
                await operationInFlight;
            } catch (error) {
                console.warn('[Cart gifts] Operacja prezentu zakończyła się błędem przed checkoutem.', error);
            }
        }

        const cart = await fetchCart();
        return enforceGiftRules(cart);
    }

    async function chooseGift(gift, card) {
        if (!gift || operationInFlight) return;

        operationInFlight = (async function () {
            setBusy(true);

            const cart = await getCartForGiftChoice(gift, card);
            let cartAfterRemoval = cart;

            if (cart) {
                const subtotal = getSubtotalWithoutGifts(cart);

                if (subtotal < gift.threshold) return cart;

                let updateResponse = null;

                try {
                    updateResponse = await setSelectedGiftWithCartUpdate(cart, gift);
                } catch (error) {
                    if (useCartUpdateFallback) throw error;
                    console.warn('[Cart gifts] Szybka zmiana prezentu przez cart/update.js nie powiodła się, używam fallbacku.', error);
                }

                if (updateResponse) {
                    const updatedCart = getCartFromResponse(updateResponse);
                    const optimisticCart = updatedCart || buildCartWithSelectedGift(cart, gift, updateResponse);

                    if (optimisticCart) {
                        updateWidgets(optimisticCart);
                    }

                    return refreshAfterMutation(updateResponse, optimisticCart);
                }

                for (const item of getGiftItems(cart)) {
                    cartAfterRemoval = await changeLineItem(item.key, 0);
                }
            } else if (!isGiftCardUnlocked(card)) {
                return cart;
            }

            const addResponse = await addGift(gift);
            const optimisticCart = buildCartWithSelectedGift(cartAfterRemoval || cart, gift, addResponse);

            if (optimisticCart) {
                updateWidgets(optimisticCart);
            }

            return refreshAfterMutation(addResponse, optimisticCart);
        })();

        try {
            return await operationInFlight;
        } catch (error) {
            console.warn('[Cart gifts] Nie udało się dodać prezentu do koszyka.', error);

            try {
                const cart = await fetchCart();
                updateWidgets(cart);
                return cart;
            } catch (refreshError) {
                console.warn('[Cart gifts] Nie udało się pobrać koszyka po błędzie operacji.', refreshError);
                if (lastCart) updateWidgets(lastCart);
                return lastCart;
            }
        } finally {
            operationInFlight = null;
            setBusy(false);

            if (lastCart) {
                updateWidgets(lastCart);
            }
        }
    }

    function scheduleRefresh() {
        if (updateTimer) {
            window.clearTimeout(updateTimer);
        }

        updateTimer = window.setTimeout(async function () {
            try {
                const cart = await fetchCart();
                updateWidgets(cart);
                await enforceGiftRules(cart);
            } catch (error) {
                console.warn('[Cart gifts] Nie udało się odświeżyć danych koszyka.', error);
                if (lastCart) updateWidgets(lastCart);
            }
        }, 120);
    }

    document.addEventListener('click', function (event) {
        const button = event.target.closest('[data-cart-gift-add]');
        if (!button || button.disabled) return;

        const card = button.closest('[data-cart-gift]');
        const gift = card ? getGiftByVariantId(card.dataset.giftVariantId) : null;
        chooseGift(gift, card);
    });

    document.addEventListener(
        'input',
        function (event) {
            const input = event.target.closest('[data-cart-gift-quantity]');
            if (!input || input.value === '1') return;

            input.value = '1';
            event.stopImmediatePropagation();
        },
        true
    );

    document.addEventListener(
        'change',
        function (event) {
            const input = event.target.closest('[data-cart-gift-quantity]');
            if (!input || input.value === '1') return;

            input.value = '1';
            event.stopImmediatePropagation();
        },
        true
    );

    document.addEventListener(
        'click',
        function (event) {
            const acceleratedCheckout = event.target.closest(
                '.cart__dynamic-checkout-buttons, .cart-drawer__dynamic-checkout-buttons'
            );

            if (!acceleratedCheckout || !hasGiftRuleViolations(lastCart)) return;

            event.preventDefault();
            event.stopImmediatePropagation();

            normalizeGiftRules().catch((error) => {
                console.warn('[Cart gifts] Nie udało się poprawić prezentów przed szybką płatnością.', error);
            });
        },
        true
    );

    window.kremLabCartGifts = {
        normalize: normalizeGiftRules,
    };

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', scheduleRefresh);
    } else {
        scheduleRefresh();
    }

    document.addEventListener('shopify:section:load', scheduleRefresh);
    document.addEventListener('krem:parcel-locker-updated', scheduleRefresh);

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdateFinish) {
        subscribe(PUB_SUB_EVENTS.cartUpdateFinish, scheduleRefresh);
        subscribe(PUB_SUB_EVENTS.quantityUpdateFinish, scheduleRefresh);
    }
})();
